<div class="form-group"><label *ngIf="label" for="">{{label}}</label>
   <div *ngFor="let item of items;let idx=index" class="custom-control mb-2 custom-checkbox">
      <input (change)="updated(item.value)" [checked]="value.indexOf(item.value)>-1" type="checkbox" class="custom-control-input" [id]="'cb-'+idx" name="example1">
      <label class="custom-control-label" [for]="'cb-'+idx">{{item.label}}</label>
   </div>
</div>
